import { call, delay, put, select, takeEvery } from "redux-saga/effects";

import {
  backgroundTaskDismissed,
  backgroundTaskFinished,
  backgroundTaskProgress
} from "Store/backgroundTasks/actions";
import { fetchClassroomAssignmentProgressApi } from "Store/backgroundTasks/api";
import * as taskTypes from "Store/backgroundTasks/constants";
import { handleFetchClassroom } from "Store/classrooms/actions";
import { makeSelectActiveClassroom } from "Store/classrooms/selectors";
import { Toast } from "utils/toast";

const POLL_INTERVAL = 2500;
const MAX_CONSECUTIVE_ERRORS = 3;
const DISMISS_AFTER = 6000;

export function* watchAssignmentProgressSaga(action: taskTypes.IBackgroundTaskStarted) {
  const { id, classroomId, kind } = action.payload;
  const verb = kind === "remove" ? "removed" : "assigned";
  const Verb = kind === "remove" ? "Removed" : "Assigned";
  let total = action.payload.total;
  let processed = 0;
  let failed = 0;
  let consecutiveErrors = 0;
  let pollingBroken = false;

  while (true) {
    yield delay(POLL_INTERVAL);
    const { data, error } = yield call(fetchClassroomAssignmentProgressApi, id);
    if (error) {
      consecutiveErrors += 1;
      if (consecutiveErrors >= MAX_CONSECUTIVE_ERRORS) {
        pollingBroken = true;
        break;
      }
      continue;
    }
    consecutiveErrors = 0;
    total = data.total;
    processed = data.processed;
    failed = data.failed;
    if (data.finished) break;
    yield put(backgroundTaskProgress({ id, processed, failed, total }));
  }

  yield put(backgroundTaskFinished({ id, processed, failed, total }));

  const activeClassroom = yield select(makeSelectActiveClassroom);
  if (activeClassroom?.id === classroomId) {
    yield put(handleFetchClassroom(classroomId));
  }

  if (pollingBroken) {
    Toast.info(
      `Students are still being ${verb} in the background. Refresh the page to see the result.`
    );
  } else if (failed > 0) {
    Toast.warning(`${Verb} ${processed} of ${total} students (${failed} failed)`);
  } else {
    Toast.success(`All ${total} students have been ${verb}`);
  }

  yield delay(DISMISS_AFTER);
  yield put(backgroundTaskDismissed({ id }));
}

export default function* backgroundTasksSaga() {
  yield takeEvery(taskTypes.BACKGROUND_TASK_STARTED, watchAssignmentProgressSaga);
}
